import { request } from "./_request";
import moment from "moment";
import { formatData } from "../helpers/dealerProfile";

export const getChart = (type, idIndicator, idBrand, year) => {
  return (dispatch, getState) => {
    dispatch({
      type: "LOADING_CHART_DEALER_PROFILE",
      payload: { type: type, loading: true },
    });

    const user = JSON.parse(localStorage.getItem("@@auth_user"));

    request
      .get("/dealer_profile/chart", {
        params: { year: year, idIndicator: idIndicator, idBrand: idBrand },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let data = response.data;

        if (!data.error) {
          dispatch({
            type: "READY_DATA_CHART_DEALER_PROFILE",
            payload: { data: data.result, type: type },
          });
        } else {
          if (data.code == -1) {
            localStorage.removeItem("@@auth_user");
            dispatch({
              type: "ERROR_TOKEN_MAIN",
              payload: { message: data.message, code: -1 },
            });
            dispatch({
              type: "LOADING_CHART_DEALER_PROFILE",
              payload: { type: type, loading: false },
            });
          } else {
            dispatch({ type: "ERROR_DEALER_PROFILE", payload: data.message });
            dispatch({
              type: "LOADING_CHART_DEALER_PROFILE",
              payload: { type: type, loading: false },
            });
          }
        }
      })
      .catch((e) => {
        dispatch({ type: "ERROR_DEALER_PROFILE", payload: e.message });
        dispatch({
          type: "LOADING_CHART_DEALER_PROFILE",
          payload: { type: type, loading: false },
        });
      });
  };
};

export const getByYears = (type, idBrand, year) => {
  return (dispatch, getState) => {
    dispatch({
      type: "LOADING_CHART_DEALER_PROFILE",
      payload: { type: type, loading: true },
    });

    const user = JSON.parse(localStorage.getItem("@@auth_user"));

    request
      .get("/dealer_profile/chartAnio", {
        params: { year: year, sucursal: idBrand },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let data = response.data;
        const date = new Date();
        const yearEnd = date.getFullYear();


        if (!data.error) {
          dispatch({
            type: "READY_DATA_CHART_DEALER_PROFILE",
            payload: { data: data.result, type: type },
          });
        } else {
          if (data.code == -1) {
            localStorage.removeItem("@@auth_user");
            dispatch({
              type: "ERROR_TOKEN_MAIN",
              payload: { message: data.message, code: -1 },
            });
            dispatch({
              type: "LOADING_CHART_DEALER_PROFILE",
              payload: { type: type, loading: false },
            });
          } else {
            dispatch({ type: "ERROR_DEALER_PROFILE", payload: data.message });
            dispatch({
              type: "LOADING_CHART_DEALER_PROFILE",
              payload: { type: type, loading: false },
            });
          }
        }
      })
      .catch((e) => {
        dispatch({ type: "ERROR_DEALER_PROFILE", payload: e.message });
        dispatch({
          type: "LOADING_CHART_DEALER_PROFILE",
          payload: { type: type, loading: false },
        });
      });
  };
};

export const getData = (year, month, type, vsMorD) => {
  return (dispatch, getState) => {
    dispatch({ type: "LOADING_DEALER_PROFILE", payload: true });

    const user = JSON.parse(localStorage.getItem("@@auth_user"));

    request
      .get("/dealer_profile/data", {
        params: { year: year, month: month, type: type },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let data = response.data;

        if (!data.error) {
          formatData(data.result, year, month, type, vsMorD).then((result) => {
            console.log(result);
            dispatch({
              type: "READY_DATA_DEALER_PROFILE",
              payload: { data: result, rawData: data.result },
            });
          });
        } else {
          if (data.code == -1) {
            localStorage.removeItem("@@auth_user");
            dispatch({
              type: "ERROR_TOKEN_MAIN",
              payload: { message: data.message, code: -1 },
            });
            dispatch({ type: "ERROR_DEALER_PROFILE", payload: data.message });
          } else {
            dispatch({ type: "ERROR_DEALER_PROFILE", payload: data.message });
          }
        }
      })
      .catch((e) => {
        dispatch({ type: "ERROR_DEALER_PROFILE", payload: e.message });
      });
  };
};

export const getSelect = (year, month, type, vsMorD) => {
  return (dispatch, getState) => {
    dispatch({ type: "LOADING_DEALER_PROFILE", payload: true });

    const user = JSON.parse(localStorage.getItem("@@auth_user"));

    request
      .get("/dealer_profile/select", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let data = response.data;

        if (!data.error) {
          dispatch({
            type: "READY_SELECT_DEALER_PROFILE",
            payload: data.result,
          });
        } else {
          if (data.code == -1) {
            localStorage.removeItem("@@auth_user");
            dispatch({
              type: "ERROR_TOKEN_MAIN",
              payload: { message: data.message, code: -1 },
            });
            dispatch({ type: "ERROR_DEALER_PROFILE", payload: data.message });
          } else {
            dispatch({ type: "ERROR_DEALER_PROFILE", payload: data.message });
          }
        }
      })
      .catch((e) => {
        dispatch({ type: "ERROR_DEALER_PROFILE", payload: e.message });
      });
  };
};

export const changeDate = (year, month) => {
  return (dispatch, getState) => {
    dispatch({
      type: "CHANGE_DATE_DEALER_PROFILE",
      payload: { year: year, month: month },
    });
  };
};

export const changeTypeData = (type) => {
  return (dispatch, getState) => {
    dispatch({ type: "CHANGE_TYPE_DATA_DEALER_PROFILE", payload: type });
  };
};

export const changeSelectStatusChart = (type, select, value) => {
  return (dispatch, getState) => {
    let selectStatusChart = getState().dealerProfile.selectStatusChart;
    if (select === "idBrand" || select === "idIndicator" || select === "year") {
      dispatch({
        type: "READY_DATA_CHART_DEALER_PROFILE",
        payload: { data: null, type: type },
      });
    }
    dispatch({
      type: "CHANGE_SELECT_CHART_DEALER_PROFILE",
      payload: { type: type, select: select, value: value },
    });
  };
};

export const changeType = (type) => {
  return (dispatch, getState) => {
    dispatch({ type: "LOADING_DEALER_PROFILE", payload: true });
    let rawData = getState().dealerProfile.rawData;
    let year = getState().dealerProfile.year;
    let month = getState().dealerProfile.month;
    let vsMorD = getState().dealerProfile.vsMorD;
    formatData(rawData, year, month, type, vsMorD).then((result) => {
      dispatch({
        type: "CHANGE_TYPE_DEALER_PROFILE",
        payload: { data: result, type: type, vsMorD: vsMorD },
      });
    });
  };
};

export const changeVsMorD = (vsMorD) => {
  return (dispatch, getState) => {
    dispatch({ type: "LOADING_DEALER_PROFILE", payload: true });
    let rawData = getState().dealerProfile.rawData;
    let year = getState().dealerProfile.year;
    let month = getState().dealerProfile.month;
    let type = getState().dealerProfile.type;
    formatData(rawData, year, month, type, vsMorD).then((result) => {
      dispatch({
        type: "CHANGE_TYPE_DEALER_PROFILE",
        payload: { data: result, type: type, vsMorD: vsMorD },
      });
    });
  };
};
